<template>
  <LinkCss :href="getWithHost(tailwindCss)" v-model:on-load-end="show" />

  <body v-if="show" class="text-base">
    <div class="mb-5 text-3xl font-semibold">
      {{ props.bookInfo.name }}
    </div>
    <div class="grid grid-cols-[1fr_minmax(150px,_300px)]">
      <div class="product-show">
        <div class="product-show__images relative max-w-full">
          <ProductImages
            v-if="props.bookInfo.images"
            :images-url="props.bookInfo.images"
            @event:image-clicked="emit('event:imageClicked', $event)"
          >
          </ProductImages>
          <ProductCircleProccent
            :item="props.bookInfo"
            class="absolute right-0 top-0"
          ></ProductCircleProccent>
        </div>
        <div class="product-show__description-mini">
          <div class="mb-6" v-if="props.bookInfo.select_data">
            <ProductSelect :select-data="props.bookInfo.select_data"></ProductSelect>
          </div>
          <ProductDescription
            @read-full="toFullDescription(false)"
            class="mb-6"
            :label="'О товаре'"
            :mini-mode="true"
          >
            {{ props.bookInfo.short_description }}
          </ProductDescription>
          <ProductCharacteristic
            v-if="showCharacteristic"
            @read-full="toFullDescription(true)"
            :mini-mode="true"
            :characteristic="props.bookInfo.characteristic!"
          >
          </ProductCharacteristic>
        </div>
        <div ref="descriptionFull" class="product-show__description-full">
          <ProductDescription :label="'Описание'" class="mb-6">
            <slot></slot>
          </ProductDescription>
          <div ref="characteristicFull">
            <ProductCharacteristic
              v-if="showCharacteristic"
              :characteristic="props.bookInfo.characteristic!"
            >
            </ProductCharacteristic>
          </div>
        </div>
      </div>
      <div class="relative mx-2">
        <div class="sticky left-0 top-0 rounded-sm p-3 shadow-lg">
          <div class="mb-4">
            <ProductPrice :item="props.bookInfo"></ProductPrice>
          </div>
          <ProductButton
            v-if="(props.bookInfo.count ?? 0) > 0"
            :product-id="props.bookInfo.id"
            @open-basket="emit('open-basket', props.bookInfo)"
            @to-basket="emit('to-basket', props.bookInfo)"
          >
          </ProductButton>
        </div>
      </div>
    </div>
  </body>
</template>
<script lang="ts" setup>
import LinkCss from '@/components/LinkCss.vue'
import ProductImages from '@/components/product/ProductImages.ce.vue'
import ProductDescription from '@/components/product/ProductDescription.vue'
import ProductCharacteristic from '@/components/product/ProductCharacteristic.vue'
import ProductCircleProccent from '@/components/product/ProductCircleProccent.vue'
import ProductPrice from '@/components/product/ProductPrice.vue'
import ProductSelect from '@/components/product_select/ProductSelect.vue'
import { getWithHost } from '@/utils/utils'
import { computed, ref, useTemplateRef } from 'vue'
import { useElementBounding } from '@vueuse/core'
import { type BookItem } from '@/types/book_item'
import tailwindCss from '@/styles/style.css?url'
import ProductButton from '@/components/product//ProductButton.vue'

const show = ref(false)

const elBounding = useTemplateRef('descriptionFull')
const elBoundingCharacteristic = useTemplateRef('characteristicFull')

const elementBounding = useElementBounding(elBounding)
const elementBoundingCharacteristic = useElementBounding(elBoundingCharacteristic)

const toFullDescription = (isCharacteristick: boolean) => {
  if (isCharacteristick) {
    window.scrollBy(0, elementBoundingCharacteristic.top.value)
    return
  }
  window.scrollBy(0, elementBounding.top.value)
}
const props = defineProps<{
  bookInfo: BookItem
}>()

const emit = defineEmits<{
  (e: 'to-basket', v: BookItem): void
  (e: 'open-basket', v: BookItem): void
  (e: 'event:imageClicked', index: number): void
}>()

const showCharacteristic = computed(() => {
  if (!props.bookInfo.characteristic) {
    return false
  } else if (props.bookInfo.characteristic.length == 0) {
    return false
  }
  return true
})
</script>
<style scoped lang="sass">
.product-show
  display: grid
  grid-template-columns: minmax(400px, 1fr) 1fr
  grid-template-rows: repeat(2, auto)
  grid-column-gap: 0px
  grid-row-gap: 0px
  gap: 20px
  &__images
    grid-area: 1 / 1 / 2 / 2
  &__description-mini
    grid-area: 1 / 2 / 2 / 3
  &__description-full
    grid-area: 2 / 1 / 3 / 3
</style>
